import { ID } from 'shared/types/id';

export type ItemBase = { id: ID; parentIds?: ID[] | null };

export const groupItems = <Item extends ItemBase>(items: Item[]): Item[] => {
  const idToItem = new Map(items.map((item) => [item.id, item]));
  const reordered: Item[] = [];
  const visited = new Set<string>();

  // Create a map of parent IDs to their children for faster lookup
  const parentToChildren = new Map<ID, Item[]>();

  items.forEach((item) => {
    const parentId = item.parentIds?.slice(-1)[0];
    if (parentId) {
      if (!parentToChildren.has(parentId)) {
        parentToChildren.set(parentId, []);
      }
      parentToChildren.get(parentId)!.push(item);
    }
  });

  // Recursive function to add an item and all its descendants
  const addItemAndDescendants = (item: Item) => {
    if (visited.has(item.id)) {
      return;
    }

    visited.add(item.id);
    reordered.push(item);

    // Get children directly from the map and process them recursively
    const children = parentToChildren.get(item.id) || [];
    children.forEach(addItemAndDescendants);
  };

  // Process each item that doesn't have a parent in our items list
  items.forEach((item) => {
    const parentId = item.parentIds?.slice(-1)[0];
    // Skip if already visited or if parent exists in our items
    if (visited.has(item.id) || (parentId && idToItem.has(parentId))) {
      return;
    }

    addItemAndDescendants(item);
  });

  return reordered;
};
